import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useMutation, useQuery } from "@apollo/client";
import { GET_OPEN_TODAY_PICKUP_ORDER_LIST, GET_ORDER_FOR_PAYMENT } from "../graphql/Query/Order.js";
import { capitalizeFirstLetter } from "../OrderPage/AllOrders.js";
import SpinLoader from "../components/SpinLoader.js";
import moment from "moment";
import { Link, useLocation } from "react-router-dom";
import NoDataFound from "../components/NoDataFound.js";
import CustomPagination from "../components/Pagination.js";
import AdminHeader from "./AdminHeader.js";
import { UPDATE_BULK_ORDER_STATUS, UPDATE_TODAY_PAYMENT_STATUS } from "../graphql/Mutation/Ordre.js";
import { warehouseOptions } from "../DomesticSellerOrder/AllOrderSeller.js";
import { toast } from "react-toastify";
import Table from "../components/Table/index.jsx";

const typeOptions = [
    { value: "", label: "All" },
    { value: "delivered", label: "Delivered" },
    { value: "rto", label: "RTO" },
    { value: "rto in transit", label: "Rto In Transit" },
    { value: "rto lost", label: "Rto Lost" },
    { value: "rto damaged", label: "Rto Damaged" },
    { value: "rto delivered", label: "Rto Delivered" },
];



const PendingPickupOrderList = () => {
    const location = useLocation();
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [filter, setFilter] = useState('');
    const [orderData, setOrderData] = useState([]);
    const [toDate, setToDate] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [searchUser, setSearchUser] = useState('');
    const [isOpenTodayPickup, setOpenTodayPickup] = useState('');
    const [filterOrder, setFilterOrder] = useState('');
    const [awbNumber, setawbNumber] = useState('');
    const [orderStatus, setorderStatus] = useState('');
    const [mainCheckbox, setMainCheckbox] = useState(false);
    const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
    const [isOn, setIsOn] = useState({});
    const [updateBulkOrderStatus] = useMutation(UPDATE_BULK_ORDER_STATUS);
    const [selectedDayRange, setSelectedDayRange] = useState(""); // Logical value
    const [displayedDayRange, setDisplayedDayRange] = useState({ label: "All", value: "" }); // Displayed value

    const [openClosePickup] = useMutation(UPDATE_TODAY_PAYMENT_STATUS);

    // const toggleSwitch = () => setIsOn(!isOn);
    const toggleSwitch = async (id) => {
        try {
            const newIsOn = !isOn[id];
            const paymentStatus = !newIsOn ? false : true
            const { data } = await openClosePickup({ variables: { input: { id: id, isOpenTodayPickup: paymentStatus } } });
            if (data?.updateTodayOpenCloseStatus) {
                refetch();
                setIsOn(prev => ({ ...prev, [id]: newIsOn }));
            } else {
                console.error('Failed to update payment status');
            }
        } catch (error) {
            console.error('Error updating payment status:', error);
        }
    };
    const { data: GetOrderOrder, loading, refetch } = useQuery(GET_OPEN_TODAY_PICKUP_ORDER_LIST, {
        variables: {
            page: page,
            limit,
            "sort": {
                "key": "createdAt",
                "type": -1
            },
            "filter": filter.trim(),
            "from": fromDate,
            "to": toDate,
            "orderStatus": orderStatus,
            "isOpenTodayPickup": isOpenTodayPickup,
            customerId: location?.state?.customerId,
            dayRange: selectedDayRange
        },
        fetchPolicy: "cache-and-network"
    })
    const fromDateChange = (e) => {
        setFromDate(e.target.value);
        setSelectedCheckboxes([]);;
    }

    const toDateChange = (e) => {
        setToDate(e.target.value);
        setSelectedCheckboxes([]);;
    }
    const handleSearch = (e, awb) => {
        setSelectedCheckboxes([]);
        if (awb === 'orderId') {
            setFilterOrder(e.target.value);
            setFilter(e.target.value)
        } else if (awb === 'awbNumber') {
            setFilter(e.target.value);
            setawbNumber(e.target.value)
        } else {
            setFilter(e.target.value);
        }
        setPage(0);

    }
    useEffect(() => {
        if (GetOrderOrder?.getOpenTodayPickupOrderList?.data) {
            setOrderData(GetOrderOrder?.getOpenTodayPickupOrderList?.data);
        }
    }, [GetOrderOrder]);
    const [activeTab, setActiveTab] = useState("All");

    const handleTabClick = (tab) => {
        setActiveTab(tab);
        if (tab === 'Pending Pickup') {
            setOpenTodayPickup('true')
        } else if (tab === 'Success Pickup') {
            setOpenTodayPickup('false')
        } else {
            setOpenTodayPickup();
        }
    };
    const handlePageClick = (selectedPage) => {
        setPage(selectedPage);
        // refetch(); // Refetch data with the new page
    };

    const resetData = () => {
        setPage(0);
        setToDate("");
        setFromDate("");
        setFilter("");
        setSearchUser("");
        setawbNumber("");
        setFilterOrder("");
        setorderStatus('');
        setSelectedDayRange("")
        setDisplayedDayRange({ label: "All", value: "" }); // Display "All" in the Select dropdown
    }



    const handleMainCheckboxChange = (e) => {
        const isChecked = e.target.checked;
        setMainCheckbox(isChecked);
        if (isChecked) {
            // Select all checkboxes
            setSelectedCheckboxes(orderData.map((_, index) => index));
        } else {
            // Deselect all checkboxes
            setSelectedCheckboxes([]);
        }
    };

    const handleRowCheckboxChange = (index) => {
        if (selectedCheckboxes.includes(index)) {
            // Remove the index from selected checkboxes
            setSelectedCheckboxes((prev) => prev.filter((i) => i !== index));
        } else {
            // Add the index to selected checkboxes
            setSelectedCheckboxes((prev) => [...prev, index]);
        }
    };

    useEffect(() => {
        // Update main checkbox if all rows are selected or deselected
        setMainCheckbox(selectedCheckboxes.length === orderData.length);
    }, [selectedCheckboxes, orderData]);

    const handleBulkUpdate = async () => {
        const orderIds = selectedCheckboxes.map((index) => orderData[index].id);
        const isOpenTodayPickup = false; // Example status, adjust as needed

        try {
            const response = await updateBulkOrderStatus({
                variables: { input: { orderIds, isOpenTodayPickup } },
            });

            // console.log('✌️response --->', response);
            if (response?.data?.updateTodayOpenCloseStatusBulk) {
                toast.success("status update successful!");
                refetch();
                // Optionally refetch data here
            } else {
                toast.error("status update failed")
            }
        } catch (error) {
            console.error("Error during bulk update:", error);
        }
    };

    const columns = [
        {
            name: "No.",
            selector: (row, index) => index + 1 + ((page - 1) * limit),
            sortable: true,
        },
        {
            name: "Shipment Date",
            selector: (row) => moment(row.createdAt).format("DD/MM/YYYY"),
            sortable: true,
        },
        {
            name: "AWB No.",
            selector: (row) => row.awb_number,
            cell: (row) => <a href="/admintrack" className="text-blue-500 underline">{row.awb_number}</a>,
        },
        {
            name: "CF ID",
            selector: (row) => row.order_id,
        },
        {
            name: "Shipment ID",
            selector: (row) => row?.order_number,
            cell: (row) => <span className="truncate max-w-xs cursor-pointer">{row?.order_number}</span>,
        },
        {
            name: "Receiver Details (To)",
            cell: (row) => (
                <div className="truncate max-w-xs cursor-pointer" title={`${row.deliveryAddress?.address1}, ${row.deliveryAddress?.city}, ${row.deliveryAddress?.stateId?.name} - ${row.deliveryAddress?.zipCode}`}>
                    {`${row.deliveryAddress?.address1}, ${row.deliveryAddress?.city}, ${row.deliveryAddress?.stateId?.name} - ${row.deliveryAddress?.zipCode}`}
                </div>
            ),
        },
        {
            name: "COD Collectable (₹)",
            selector: (row) => row.payment_type === "cod" ? `₹${row.ProductPrice}` : "-",
        },
        {
            name: "COD Collection (₹)",
            selector: (row) => `₹${row.codCollectableValue}`,
        },
        {
            name: "Payment Type",
            selector: (row) => row.payment_type,
        },
        {
            name: "RTO Charge (₹)",
            selector: (row) => row.rto_order_charge || 0,
        },
        {
            name: "Shipment Charge (₹)",
            selector: (row) => row.order_amount || 0,
        },
        {
            name: "Total Amount (₹)",
            selector: (row) => row.final_order_amount || 0,
        },
        {
            name: "Net Payable Amount (₹)",
            selector: (row) => row.net_receivable_amount || 0,
        },
        {
            name: "Payment Amount Date",
            selector: (row) => row.payment_order_Date ? moment(row.payment_order_Date).format("DD/MM/YYYY") : "-",
        },
        {
            name: "Status",
            selector: (row) => row.status,
            cell: (row) => (
                <span className={`px-3 py-1 rounded-lg text-sm font-semibold bg-${row.status === "delivered" ? "green-100 text-green-600" : "gray-100 text-gray-600"}`}>
                    {row.status}
                </span>
            ),
        },
        {
            name: "Update Status",
            cell: (row) => (
                <div
                    className={`relative inline-flex items-center h-6 w-12 cursor-pointer rounded-full transition-colors ${row.isOpenTodayPickup ? "bg-green-500" : "bg-slate-300"}`}
                    onClick={() => toggleSwitch(row.id)}
                >
                    <span
                        className={`absolute left-0 top-1/2 h-5 w-5 rounded-full bg-white shadow transform transition-transform ${row.isOpenTodayPickup ? "translate-x-6 -translate-y-1/2" : "translate-x-1 -translate-y-1/2"}`}
                    ></span>
                </div>
            ),
        },
    ];
    return (
        <>
            <AdminHeader />
            <div className="mx-auto max-w-auto px-4 sm:px-6 lg:px-8">
                {/* Header Section */}
                <div className="bg-slate-50 border border-slate-300 p-6 rounded-lg my-6">
                    <div className="flex flex-col md:flex-row justify-between items-center w-full">
                        <h1 className="text-lg font-bold text-gray-800">
                            {location?.state?.email}
                        </h1>

                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-4">
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">Search Anything</label>
                            <input
                                type="text"
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                                placeholder="Type here..."
                                value={searchUser}
                                onChange={(e) => { setSearchUser(e.target.value); handleSearch(e); setSelectedCheckboxes([]); }}
                            />
                        </div>


                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">AWB No.</label>
                            <input
                                type="text"
                                value={awbNumber}
                                onChange={(e) => { setawbNumber(e.target.value); handleSearch(e, 'awbNumber'); setSelectedCheckboxes([]); }}
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                                placeholder="Enter AWB No."
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">Shipment IDs</label>
                            <input
                                type="text"
                                value={filterOrder}
                                onChange={(e) => { setFilterOrder(e.target.value); handleSearch(e, 'orderId') }}
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                                placeholder="Enter Shipment ID"
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">Type</label>
                            <Select
                                options={typeOptions}
                                defaultValue={typeOptions[0]}
                                className="w-full"
                                onChange={(selectedOption) => { setorderStatus(selectedOption?.value); setSelectedCheckboxes([]); }}
                                classNamePrefix="react-select"
                                styles={{
                                    control: (base, state) => ({
                                        ...base,
                                        borderColor: state.isFocused ? '#64748B' : '#64748B',
                                        '&:hover': { borderColor: '#64748B' },
                                        boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                        borderRadius: '0.375rem',
                                        // paddingTop: '-0.5px', // py-1 corresponds to 0.25rem (4px) on top
                                        // paddingBottom: '-0.5px',
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        color: '#000000',
                                        fontSize: '0.875rem',
                                    }),
                                    option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                        color: state.isSelected ? 'white' : '#000000',
                                        fontSize: '0.875rem',
                                        '&:hover': {
                                            backgroundColor: '#f0f0f0',
                                            color: '#000000',
                                            fontSize: '0.875rem',
                                        }
                                    }),
                                    placeholder: (base) => ({
                                        ...base,
                                        fontSize: '0.875rem',
                                        color: '#A3AAB5',
                                    }),
                                }}
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">From Date</label>
                            <input
                                type="date"
                                value={fromDate}
                                onChange={fromDateChange}
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-2">To Date</label>
                            <input
                                type="date"
                                value={toDate}
                                onChange={toDateChange}
                                className="block focus:outline-none focus:ring-slate-600 focus:border-slate-600 w-full rounded-md border-0 px-3.5 py-1 text-gray-900 ring-1 ring-inset ring-slate-400 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:leading-6"
                            />
                        </div>

                        <div className="flex flex-col">
                            <label className="text-sm text-gray-700 mb-1">Date Range</label>
                            <Select
                                options={warehouseOptions}
                                // defaultValue={channelOptions[0]}
                                className="w-full"
                                value={displayedDayRange} // Controls the displayed value
                                onChange={(selectedOption) => {
                                    setSelectedDayRange(selectedOption?.value); // Update logical value
                                    setDisplayedDayRange(selectedOption); // Update displayed value
                                    setSelectedCheckboxes([]);
                                }}
                                classNamePrefix="react-select"
                                styles={{
                                    control: (base, state) => ({
                                        ...base,
                                        borderColor: state.isFocused ? '#64748B' : '#64748B',
                                        '&:hover': { borderColor: '#64748B' },
                                        boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                        borderRadius: '0.375rem',
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        color: '#000000',
                                        fontSize: '0.875rem',
                                    }),
                                    option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                        color: state.isSelected ? 'white' : '#000000',
                                        fontSize: '0.875rem',
                                        '&:hover': {
                                            backgroundColor: '#f0f0f0',
                                            fontSize: '0.875rem',
                                            color: '#000000',
                                        }
                                    }),
                                    placeholder: (base) => ({
                                        ...base,
                                        fontSize: '0.875rem',
                                        color: '#A3AAB5',

                                    }),
                                }}
                            />
                        </div>


                        {/* <div className="flex flex-col">
                        <label className="text-sm text-gray-700 mb-1">Warehouse</label>
                        <Select
                            options={warehouseOptions}
                            defaultValue={warehouseOptions[0]}
                            className="w-full"
                            classNamePrefix="react-select"
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused ? '#64748B' : '#64748B',
                                    '&:hover': { borderColor: '#64748B' },
                                    boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                    borderRadius: '0.375rem',
                                }),
                                singleValue: (base) => ({
                                    ...base,
                                    color: '#000000',
                                }),
                                option: (base, state) => ({
                                    ...base,
                                    backgroundColor: state.isSelected ? '#000000' : state.isFocused ? '#f0f0f0' : 'white',
                                    color: state.isSelected ? 'white' : '#000000',
                                    '&:hover': {
                                        backgroundColor: '#f0f0f0',
                                        color: '#000000',
                                    }
                                }),
                                placeholder: (base) => ({
                                    ...base,
                                    fontSize: '14px',
                                    color: '#A3AAB5',
                                }),
                            }}
                        />
                    </div> */}




                        <div className="mt-6 flex gap-4">
                            <button className="bg-slate-500 text-white px-4 py-1 rounded-lg text-sm hover:bg-slate-600" onClick={resetData}>
                                Clear
                            </button>
                        </div>
                    </div>

                </div>


                {/* Tab Section */}
                <div className="bg-white px-4 py-3 border-s-0 border-r-0 border-t border-b border-slate-300 mb-4">
                    <div className="flex flex-wrap gap-4">
                        {[
                            "All",
                            "Pending Pickup",
                            "Success Pickup",
                            // "In Transit",
                            // "Out For Delivery",
                            // "Delivered",
                        ].map((tab) => (
                            <button
                                key={tab}
                                className={`font-semibold border-b-2 px-2 py-1 text-sm ${activeTab === tab
                                    ? "text-blue-600 border-blue-600"
                                    : "text-gray-600 border-transparent hover:text-blue-600"
                                    }`}
                                onClick={() => handleTabClick(tab)}
                            >
                                {tab}
                                {/* {tab !== "All" && `(${GetOrderOrder?.getPaymentOrders?.count})`} */}
                            </button>
                        ))}
                    </div>
                </div>
                <div className="flex flex-col md:flex-row items-center justify-start  w-full p-4 sm:p-2">
                    <div className="flex flex-col md:flex-row items-center">
                        <h2 className="my-7 font-bold text-gray-800">
                            {location?.state?.email}

                        </h2>
                    </div>
                    {/* <div className="min-h-screen flex items-center justify-center bg-slate-100"> */}
                    {/* Open Modal Button */}

                </div>



                {/* </div> */}
                <p className="font-semibold text-sm mb-1">Selected Items: {selectedCheckboxes.length}</p>
                {activeTab !== 'Success Payment' && <button
                    className="bg-blue-500 text-white px-4 py-2 rounded"
                    onClick={handleBulkUpdate}
                    disabled={selectedCheckboxes?.length === 0}
                >
                    Update Pickup Status
                </button>}

                {/* Shipment Table Section */}

                <div className="mt-2 bg-white p-4 border rounded-lg">
                    <Table
                        columns={columns}
                        data={orderData || []}
                        currentPage={page}
                        totalRecords={orderData?.length || 0}
                        limit={limit}
                        setPage={setPage}
                        setLimit={setLimit}
                        loading={loading}
                        handlePagination={(newPage) => setPage(newPage)}
                    />
                </div>
                {/* <div className="bg-slate-50 rounded-t-lg border mb-9 border-slate-300">
                    <div className="overflow-x-auto">
                        <table className="w-full text-sm text-left border-collapse whitespace-nowrap">
                            <thead className="bg-slate-100 text-gray-700">
                                <tr>
                                    <th className="px-4 py-3 flex items-center">
                                        <input
                                            type="checkbox"
                                            className="mr-2 h-4 w-4"
                                            checked={mainCheckbox}
                                            onChange={handleMainCheckboxChange}
                                        />
                                        No.
                                    </th>
                                    <th className="px-4 py-3">Shipment Date</th>
                                    <th className="px-4 py-3">AWB No.</th>
                                    <th className="px-4 py-3">CF ID</th>
                                    <th className="px-4 py-3">Shipment ID</th>
                                    <th className="px-4 py-3">Receiver Details (To)</th>
                                    <th className="px-4 py-3">COD Collectable (₹)</th>
                                    <th className="px-4 py-3">COD Collection (₹)</th>
                                    <th className="px-4 py-3">Payment Type</th>
                                    <th className="px-4 py-3">RTO Charge (₹)</th>
                                    <th className="px-4 py-3">Shipment Charge (₹)</th>
                                    <th className="px-4 py-3">Total Amount (₹)</th>
                                    <th className="px-4 py-3">Net Payble Amount (₹)</th>
                                    <th className="px-4 py-3">Payment Amount Date</th>
                                    <th className="px-4 py-3">Status</th>
                                    <th className="px-4 py-3">Update Status </th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="16" className="text-center py-20">
                                            <SpinLoader classNamecolor="true" />
                                        </td>
                                    </tr>
                                ) : orderData?.length > 0 ? (
                                    orderData.map((shipment, index) => (
                                        <tr key={index} className="border-t bg-white">
                                            <td className="px-4 py-1 text-gray-700 flex items-center">
                                                <input
                                                    type="checkbox"
                                                    className="mr-2 h-4 w-4"
                                                    checked={selectedCheckboxes.includes(index)}
                                                    onChange={() => handleRowCheckboxChange(index)}
                                                />
                                                {page * limit + index + 1}
                                            </td>
                                            <td className="px-4 py-1 text-gray-700">
                                                {moment(shipment?.createdAt).format('DD/MM/YYYY') || '-'}
                                            </td>

                                            <td className="px-4 py-1 text-blue-500 underline cursor-pointer">
                                                <Link to="/admintrack" state={{ id: shipment?.id }}>
                                                    {shipment?.awb_number}
                                                </Link>
                                            </td>
                                            <td className="px-4 py-1 text-blue-500 underline cursor-pointer">
                                                {shipment?.order_id}
                                            </td>
                                            <td className="px-4 py-1 text-blue-500 underline cursor-pointer">
                                                <Link to="/admintrack" state={{ id: shipment?.id }}>
                                                    {shipment?.order_number}
                                                </Link>
                                            </td>
                                            <td className="relative group px-4 py-1 text-gray-700">
                                              
                                                <div className="truncate max-w-36">
                                                    {capitalizeFirstLetter(shipment?.deliveryAddress?.address1)}{" "}
                                                    {capitalizeFirstLetter(shipment?.deliveryAddress?.city)}.{" "}
                                                    {capitalizeFirstLetter(shipment?.deliveryAddress?.stateId?.name)} -{" "}
                                                    {shipment?.deliveryAddress?.zipCode}
                                                </div>

                                               
                                                <div className="absolute z-10 hidden group-hover:block bg-slate-700 text-white text-sm rounded-md px-2 py-1 shadow-lg max-w-xs whitespace-normal">
                                                
                                                    <p className="font-semibold">{shipment?.deliveryAddress?.name}</p>

                                                   
                                                    {shipment?.package_weight_Length && (
                                                        <p className="text-sm text-gray-300">Weight: {shipment?.package_weight_Length}</p>
                                                    )}

                                             
                                                    {shipment?.ProductName && (
                                                        <p className="text-sm text-gray-300">Product: {shipment?.ProductName}</p>
                                                    )}

                                                    
                                                    <p className="text-sm">
                                                        {shipment?.deliveryAddress?.address1},{" "}
                                                        {shipment?.deliveryAddress?.city}, {shipment?.deliveryAddress?.stateId?.name} -{" "}
                                                        {shipment?.deliveryAddress?.zipCode}.
                                                    </p>
                                                </div>

                                            </td>

                                            <td className="px-4 py-1 text-gray-700">
                                                {shipment?.payment_type === 'cod'
                                                    ? `₹${shipment?.ProductPrice}`
                                                    : '   -'}
                                          
                                            </td>
                                          
                                            <td className="px-4 py-1 text-gray-700">₹{shipment?.codCollectableValue}</td>
                                            <td className="px-4 py-1 text-gray-700">{shipment.payment_type}</td>
                                           
                                            <td className="px-4 py-1 text-gray-700 font-semibold">
                                                {shipment?.rto_order_charge || 0}
                                            </td>
                                            <td className="px-4 py-1 text-gray-700">{shipment?.order_amount || 0}</td>

                                            <td className="px-4 py-1 text-gray-700">
                                                {shipment?.final_order_amount || 0}
                                            </td>
                                            <td className="px-4 py-1 text-gray-700">
                                                {shipment?.net_receivable_amount || 0}
                                            </td>
                                            <td className="px-4 py-1 text-gray-700 font-semibold">
                                                {shipment?.payment_order_Date ? moment(shipment?.payment_order_Date).format('DD/MM/YYYY') : '-'}
                                            </td>

                                            <td className="px-4 py-4">
                                                <span
                                                    className={`bg-${shipment?.status === 'delivered'
                                                        ? 'green'
                                                        : shipment?.status === 'rto'
                                                            ? 'pink'
                                                            : shipment?.status === 'rto delivered'
                                                                ? 'indigo'
                                                                : 'gray'
                                                        }-100 text-${shipment?.status === 'delivered'
                                                            ? 'green'
                                                            : shipment?.status === 'rto'
                                                                ? 'pink'
                                                                : shipment?.status === 'rto delivered'
                                                                    ? 'indigo'
                                                                    : 'gray'
                                                        }-600 px-3 py-1 rounded-lg text-sm font-semibold`}
                                                >
                                                    {shipment?.status}
                                                </span>
                                            </td>
                                            <td className="px-4 py-3">
                                                <div className={`relative inline-flex items-center h-6 w-12 cursor-pointer rounded-full transition-colors ${shipment?.isOpenTodayPickup === true ? "bg-green-500" : "bg-slate-300"
                                                    }`}
                                                    onClick={() => toggleSwitch(shipment?.id)}
                                                >
                                                    <span className={`absolute left-0 top-1/2 h-5 w-5 rounded-full bg-white shadow transform transition-transform ${shipment?.isOpenTodayPickup === true ? "translate-x-6 -translate-y-1/2" : "translate-x-1 -translate-y-1/2"}`} ></span>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="16" className="text-center py-20">
                                            <NoDataFound />
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div> */}
                {/* <CustomPagination
                    totalItems={GetOrderOrder?.getOpenTodayPickupOrderList?.count || 0} // Total number of items
                    limit={limit}
                    pageNo={page} // Current page number (zero-based index)
                    handlePageClick={handlePageClick} // Handler to change page
                /> */}

                {/* Shipment Table Section */}
                {/* <div className="w-1/2">
                    <div className="bg-slate-50 rounded-t-lg border mb-9 border-slate-300">
                        <div className="overflow-x-auto">
                            <table className="w-full text-sm text-left border-collapse whitespace-nowrap">
                                <thead className="bg-slate-100 text-gray-700">
                                    <tr>
                                        <th className="px-4 py-3">No.</th>
                                        <th className="px-4 py-3">Date</th>
                                        <th className="px-4 py-3">Receive Payment</th>
                                        <th className="px-4 py-3">Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td colSpan="4" className="text-center py-20">
                                                <SpinLoader className="text-primary" />
                                            </td>
                                        </tr>
                                    ) : orderData?.length > 0 ? (
                                        orderData.map((shipment, index) => (
                                            <tr key={index} className="border-t bg-white">
                                                <td className="px-4 py-1 text-gray-700">{page * limit + index + 1}</td>
                                                <td className="px-4 py-1 text-gray-700">
                                                    {shipment?.date || "N/A"}
                                                </td>
                                                <td className="px-4 py-1 text-gray-700 font-semibold">
                                                    ₹{shipment?.receivePayment || "0"}
                                                </td>
                                                <td className="px-4 py-4">
                                                    <span
                                                        className={`bg-${shipment?.status === "delivered"
                                                            ? "green"
                                                            : shipment?.status === "rto"
                                                                ? "pink"
                                                                : shipment?.status === "rto delivered"
                                                                    ? "indigo"
                                                                    : "gray"
                                                            }-100 text-${shipment?.status === "delivered"
                                                                ? "green"
                                                                : shipment?.status === "rto"
                                                                    ? "pink"
                                                                    : shipment?.status === "rto delivered"
                                                                        ? "indigo"
                                                                        : "gray"
                                                            }-600 px-3 py-1 rounded-lg text-sm font-semibold`}
                                                    >
                                                        {shipment?.status || "Unknown"}
                                                    </span>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="4" className="text-center py-20">
                                                <NoDataFound />
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <CustomPagination
                        totalItems={GetOrderOrder?.getOpenTodayPickupOrderList?.count || 0} // Total number of items
                        limit={limit}
                        pageNo={page} // Current page number (zero-based index)
                        handlePageClick={handlePageClick} // Handler to change page
                    />

                </div> */}
            </div >
        </>
    )
}
export default PendingPickupOrderList
